import { Product, Products } from './user';

export enum PrivilegeType {
  ADMIN = 'ADMIN',
  SUBJECT = 'SUBJECT',
  USER_CATEGORY = 'USER_CATEGORY',
  ASSESSMENT_DIMENSION = 'ASSESSMENT_DIMENSION',
  CURRENCY_CONVERSION = 'CURRENCY_CONVERSION',
  INCOME_ANALYSIS = 'INCOME_ANALYSIS',
  EXPENSE_ANALYSIS = 'EXPENSE_ANALYSIS',
  VARIANCE_ANALYSIS = 'VARIANCE_ANALYSIS',
  REPORT_TEMPLATE = 'REPORT_TEMPLATE',
  TEMPLATE = 'TEMPLATE',
  PROJECT = 'PROJECT',
  ACTION_PLAN = 'ACTION_PLAN',
  PROPOSAL = 'PROPOSAL',
  SUPPORT_REQUEST = 'SUPPORT_REQUEST',
  CUSTOMER = 'CUSTOMER',
  TRADE_CATEGORY = 'TRADE_CATEGORY',
  INTERNAL_TRADE = 'INTERNAL_TRADE',
  DASHBOARD = 'DASHBOARD',
  PLAN = 'PLAN',
  OPERATIONAL_STATEMENT_TRANSACTION = 'OPERATIONAL_STATEMENT_TRANSACTION',
  // 目标与项目 / 改善项目
  PLAN_GLOBAL = 'PLAN_GLOBAL',
  PLAN_DIRECT_DEPT = 'PLAN_DIRECT_DEPT',
  PROJECT_GLOBAL = 'PROJECT_GLOBAL',
  PROJECT_DIRECT_DEPT = 'PROJECT_DIRECT_DEPT',
  // 在线交易
  INTERNAL_TRADE_GLOBAL = 'INTERNAL_TRADE_GLOBAL',
  INTERNAL_TRADE_DIRECT_DEPT = 'INTERNAL_TRADE_DIRECT_DEPT',
  OPERATIONAL_STATEMENT_TRANSACTION_GLOBAL = 'OPERATIONAL_STATEMENT_TRANSACTION_GLOBAL',
  OPERATIONAL_STATEMENT_TRANSACTION_DIRECT_DEPT = 'OPERATIONAL_STATEMENT_TRANSACTION_DIRECT_DEPT',
  INTERNAL_TRADE_APPROVE = 'INTERNAL_TRADE_APPROVE',
  // 经营分析
  EXPENSE_ANALYSIS_GLOBAL = 'EXPENSE_ANALYSIS_GLOBAL',
  EXPENSE_ANALYSIS_DIRECT_DEPT = 'EXPENSE_ANALYSIS_DIRECT_DEPT',
  VARIANCE_ANALYSIS_GLOBAL = 'VARIANCE_ANALYSIS_GLOBAL',
  VARIANCE_ANALYSIS_DIRECT_DEPT = 'VARIANCE_ANALYSIS_DIRECT_DEPT',
  INCOME_ANALYSIS_GLOBAL = 'INCOME_ANALYSIS_GLOBAL',
  INCOME_ANALYSIS_DIRECT_DEPT = 'INCOME_ANALYSIS_DIRECT_DEPT',
  // 改善项目
  PROPOSAL_GLOBAL = 'PROPOSAL_GLOBAL',
  PROPOSAL_DIRECT_DEPT = 'PROPOSAL_DIRECT_DEPT',
  ACTION_PLAN_GLOBAL = 'ACTION_PLAN_GLOBAL',
  ACTION_PLAN_DIRECT_DEPT = 'ACTION_PLAN_DIRECT_DEPT',
  SUPPORT_REQUEST_GLOBAL = 'SUPPORT_REQUEST_GLOBAL',
  SUPPORT_REQUEST_DIRECT_DEPT = 'SUPPORT_REQUEST_DIRECT_DEPT',
}
export const PRIVILEGE_PREFIX = 'AMOEBA_PRIVILEGE_';
export const WRITE_SUFFIX = '_WRITE';
export const READ_SUFFIX = '_READ';
export const APPROVE_SUFFIX = '_APPROVE';
export type PermissionObject = {
  write: boolean;
  read: boolean;
  approve?: boolean;
};
export type Priviledge = {
  id: number;
  name: string;
  displayName?: string;
};

export type Permission = {
  [key: string]: PermissionObject;
};

export interface Role {
  id?: number;
  name: string;
  displayName?: string;
  privileges?: Priviledge[];
  [key: string]: string | number | boolean | null | undefined | Priviledge[] | undefined;
}

export const getProductRoles = (products: Products[], product: Product): Role[] =>
  products.find((item) => item.name === product)?.roles ?? [];
export const convertPermission = (roles: Role[]): Permission => {
  const permissions: Permission = {
    [PrivilegeType.ADMIN]: {
      write: false,
      read: false,
    },
    [PrivilegeType.SUBJECT]: {
      write: false,
      read: false,
    },
    [PrivilegeType.USER_CATEGORY]: {
      write: false,
      read: false,
    },
    [PrivilegeType.ASSESSMENT_DIMENSION]: {
      write: false,
      read: false,
    },
    [PrivilegeType.CURRENCY_CONVERSION]: {
      write: false,
      read: false,
    },
    [PrivilegeType.INCOME_ANALYSIS]: {
      write: false,
      read: false,
    },
    [PrivilegeType.EXPENSE_ANALYSIS]: {
      write: false,
      read: false,
    },
    [PrivilegeType.VARIANCE_ANALYSIS]: {
      write: false,
      read: false,
    },
    [PrivilegeType.REPORT_TEMPLATE]: {
      write: false,
      read: false,
    },
    [PrivilegeType.TEMPLATE]: {
      write: false,
      read: false,
    },
    [PrivilegeType.PROJECT]: {
      write: false,
      read: false,
    },
    [PrivilegeType.ACTION_PLAN]: {
      write: false,
      read: false,
    },
    [PrivilegeType.PROPOSAL]: {
      write: false,
      read: false,
    },
    [PrivilegeType.SUPPORT_REQUEST]: {
      write: false,
      read: false,
    },
    [PrivilegeType.CUSTOMER]: {
      write: false,
      read: false,
    },
    [PrivilegeType.TRADE_CATEGORY]: {
      write: false,
      read: false,
    },
    [PrivilegeType.INTERNAL_TRADE]: {
      write: false,
      read: false,
    },
    [PrivilegeType.DASHBOARD]: {
      write: false,
      read: false,
    },
    [PrivilegeType.PLAN]: {
      write: false,
      read: false,
    },
    [PrivilegeType.OPERATIONAL_STATEMENT_TRANSACTION]: {
      write: false,
      read: false,
    },
    [PrivilegeType.PLAN_GLOBAL]: {
      write: false,
      read: false,
    },
    [PrivilegeType.PLAN_DIRECT_DEPT]: {
      write: false,
      read: false,
    },
    [PrivilegeType.PROJECT_GLOBAL]: {
      write: false,
      read: false,
    },
    [PrivilegeType.PROJECT_DIRECT_DEPT]: {
      write: false,
      read: false,
    },
    [PrivilegeType.INTERNAL_TRADE_GLOBAL]: {
      write: false,
      read: false,
    },
    [PrivilegeType.INTERNAL_TRADE_DIRECT_DEPT]: {
      write: false,
      read: false,
    },
    [PrivilegeType.OPERATIONAL_STATEMENT_TRANSACTION_GLOBAL]: {
      write: false,
      read: false,
    },
    [PrivilegeType.OPERATIONAL_STATEMENT_TRANSACTION_DIRECT_DEPT]: {
      write: false,
      read: false,
    },
    [PrivilegeType.EXPENSE_ANALYSIS_GLOBAL]: {
      write: false,
      read: false,
    },
    [PrivilegeType.EXPENSE_ANALYSIS_DIRECT_DEPT]: {
      write: false,
      read: false,
    },
    [PrivilegeType.VARIANCE_ANALYSIS_GLOBAL]: {
      write: false,
      read: false,
    },
    [PrivilegeType.VARIANCE_ANALYSIS_DIRECT_DEPT]: {
      write: false,
      read: false,
    },
    [PrivilegeType.INCOME_ANALYSIS_GLOBAL]: {
      write: false,
      read: false,
    },
    [PrivilegeType.INCOME_ANALYSIS_DIRECT_DEPT]: {
      write: false,
      read: false,
    },
    [PrivilegeType.PROPOSAL_GLOBAL]: {
      write: false,
      read: false,
    },
    [PrivilegeType.PROPOSAL_DIRECT_DEPT]: {
      write: false,
      read: false,
    },
    [PrivilegeType.ACTION_PLAN_GLOBAL]: {
      write: false,
      read: false,
    },
    [PrivilegeType.ACTION_PLAN_DIRECT_DEPT]: {
      write: false,
      read: false,
    },
    [PrivilegeType.SUPPORT_REQUEST_GLOBAL]: {
      write: false,
      read: false,
    },
    [PrivilegeType.SUPPORT_REQUEST_DIRECT_DEPT]: {
      write: false,
      read: false,
    },
    [PrivilegeType.INTERNAL_TRADE_APPROVE]: {
      write: false,
      read: false,
    },
  };
  roles.forEach((role) => {
    if (role.name === 'ROLE_ADMIN') {
      permissions.ADMIN.read = true;
      permissions.ADMIN.write = true;
    }
    if (role.privileges) {
      role.privileges.forEach((privilege) => {
        if (privilege.name.includes(PRIVILEGE_PREFIX)) {
          const result = getPermission(privilege.name, permissions);
          if (result?.value.read && permissions[result.key]) {
            permissions[result.key].read = true;
          }
          if (result?.value.write && permissions[result.key]) {
            permissions[result.key].write = true;
          }
          if (result?.value.approve && permissions[result.key]) {
            permissions[result.key].approve = true;
          }
        }
      });
    }
  });

  return permissions;
};

export const getPermission = (
  name: string,
  permissions: Permission
): { key: PrivilegeType; value: PermissionObject } | undefined => {
  const key = name.replace(PRIVILEGE_PREFIX, '');
  let privilegeType: PrivilegeType | null = null;
  const value: PermissionObject = { read: false, write: false };
  if (name.includes(APPROVE_SUFFIX)) {
    privilegeType = key as PrivilegeType;
    value.approve = true;
  }
  if (name.includes(WRITE_SUFFIX)) {
    privilegeType = key.replace(WRITE_SUFFIX, '') as PrivilegeType;
    value.write = true;
  }
  if (name.includes(READ_SUFFIX)) {
    privilegeType = key.replace(READ_SUFFIX, '') as PrivilegeType;
    value.read = true;
  }

  return privilegeType ? { key: privilegeType, value } : undefined;
};
